import {
  IconButton,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { Container } from './PointSituation.styled';

import { AiTwotoneEdit } from 'react-icons/ai';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { BsTrash } from 'react-icons/bs';
import PageTitle from '../../components/page-title/PageTitle';
import CustomTableSortLabel from '../../components/custom-table-sort-label/CustomTableSortLabel';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IPointSituation from '../../interfaces/IPointSituation';
import { usePointSituation } from '../../hooks/services/usePointSituatuion';
import IPage from '../../interfaces/IPage';
import CustomTablePagination from '../../components/custom-table-pagination/CustomTablePagination';

interface PointSituationProps extends IPage {}

const PointSituation = (props: PointSituationProps) => {
  window.document.title = props.title;
  const [situations, setSituations] = useState<IPointSituation[] | null>(null);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
  const [orderField, setOrderField] = useState<string>('description');
  const [loading, setLoading] = useState(false);

  const request = usePointSituation();
  const toastr = useToastrVanila();
  const navigate = useNavigate();

  const listPointSituation = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
  ) => {
    setLoading(true);
    await request
      .list(perPage, currentPage + 1, orderField, orderDirection)
      .then(result => {
        setSituations([...result?.data]);
        setTotalRows(result.totalRows);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  const removePointSituation = async (id: number) => {
    setLoading(true);
    await request
      .remove(id)
      .then(async result => {
        await listPointSituation(perPage, currentPage, orderField, orderDirection);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    listPointSituation(perPage, currentPage, orderField, orderDirection);
  }, []);

  return (
    <Container>
      <PageTitle title="LISTAGEM DE SITUAÇÕES DOS PONTOS"></PageTitle>
      <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
        {loading && <LinearProgress />}
        <Table>
          <TableHead>
            <TableRow>
              <CustomTableSortLabel
                perPage={perPage}
                currentPage={currentPage}
                orderField={orderField}
                field="id"
                label="Código"
                handleRequest={listPointSituation}
                direction={orderDirection}
                setField={setOrderField}
                setDirection={setOrderDirection}
              />
              <CustomTableSortLabel
                perPage={perPage}
                currentPage={currentPage}
                orderField={orderField}
                field="description"
                label="Descrição"
                handleRequest={listPointSituation}
                direction={orderDirection}
                setField={setOrderField}
                setDirection={setOrderDirection}
              />
              <CustomTableSortLabel
                perPage={perPage}
                currentPage={currentPage}
                orderField={orderField}
                field="allowsChange"
                label="Permitir Mudança"
                handleRequest={listPointSituation}
                direction={orderDirection}
                setField={setOrderField}
                setDirection={setOrderDirection}
              />

              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {situations &&
              situations.map(situation => {
                return (
                  <TableRow key={situation.id} hover={true}>
                    <TableCell>{situation.id}</TableCell>
                    <TableCell>{situation.description}</TableCell>
                    <TableCell>{situation.allowsChange ? 'Sim' : 'Não'}</TableCell>
                    <TableCell>
                      <Tooltip title="Editar" placement="top">
                        <IconButton onClick={() => navigate(`/point-situation/${situation.id}/edit`)}>
                          <AiTwotoneEdit style={{ fontSize: '15px' }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir" placement="top">
                        <IconButton onClick={() => removePointSituation(situation.id || 0)}>
                          <BsTrash style={{ fontSize: '15px' }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomTablePagination
        totalRows={totalRows}
        currentPage={currentPage}
        perPage={perPage}
        handleRequest={listPointSituation}
        setPerPage={setPerPage}
        setCurrentPage={setCurrentPage}
        orderField={orderField}
        orderDirection={orderDirection}
      />
    </Container>
  );
};

export default PointSituation;
